import type { IProcessActivity } from '@common/interfaces';
import { ServiceActivityType } from '@common/enums';
import { formatString } from '@common/utils/formatString';
import { getSelectedLanguage } from '@frontend/translate';

export function getModalText(
    processActivity: IProcessActivity | undefined,
    serviceActivityType: ServiceActivityType
): string {
    if (processActivity?.canBeModified) {
        if (serviceActivityType === ServiceActivityType.unknown) {
            return getSelectedLanguage().processActivity.cancel.stopModifyingDefault;
        }

        return formatString(getSelectedLanguage().processActivity.cancel.stopModifying, [
            getSelectedLanguage().serviceActivityType[`${serviceActivityType}Pronoun`],
        ]);
    }

    if (processActivity) {
        if (serviceActivityType === ServiceActivityType.unknown) {
            return getSelectedLanguage().processActivity.cancel.stopEditingDefault;
        }

        return formatString(getSelectedLanguage().processActivity.cancel.stopEditing, [
            getSelectedLanguage().serviceActivityType[`${serviceActivityType}Pronoun`],
        ]);
    }

    if (serviceActivityType === ServiceActivityType.unknown) {
        return getSelectedLanguage().processActivity.cancel.removeDefault;
    }

    return formatString(getSelectedLanguage().processActivity.cancel.remove, [
        getSelectedLanguage().serviceActivityType[serviceActivityType],
    ]);
}

export function getToastText(
    processActivity: IProcessActivity | undefined,
    serviceActivityType: ServiceActivityType
): string {
    if (processActivity?.canBeModified) {
        return getSelectedLanguage().toast.cancelModificationSuccess;
    }

    if (serviceActivityType === ServiceActivityType.unknown) {
        return getSelectedLanguage().StatusLabelEnum.cancelled;
    }

    const key = processActivity
        ? getSelectedLanguage().toast.cancelExistingSuccess
        : getSelectedLanguage().toast.cancelSuccess;

    return formatString(key, [getSelectedLanguage().serviceActivityType[serviceActivityType]]);
}
